import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from '../serviceHelper'

export const adminUserReplacementService = {
  addUserReplacement: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/user-replacements/add`,
        payload,
        getAxiosOptions(user),
      )
    ).data
  },

  getUserReplacement: async (user) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/user-replacements/get-user-replacements`,
        getAxiosOptions(user),
      )
    ).data
  },

  updateUserReplacement: async (user, payload) => {
    return (
      await axios.put(
        `${NODE_BASE_URL}/admin/user-replacements/update/${payload.id}`,
        payload,
        getAxiosOptions(user),
      )
    ).data
  },

  deleteUserReplacement: async (user, id) => {
    return (
      await axios.delete(
        `${NODE_BASE_URL}/admin/user-replacements/delete/${id}`,
        getAxiosOptions(user),
      )
    ).data
  },

  addUserReplacementLog: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/user-replacements/add-log`,
        payload,
        getAxiosOptions(user),
      )
    ).data
  },

  getUserReplacementLogs: async (user) => {
    return (
      await axios.get(`${NODE_BASE_URL}/admin/user-replacements/get-logs`, getAxiosOptions(user))
    ).data
  },

  previewTasks: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/user-replacements/preview-tasks`,
        payload,
        getAxiosOptions(user),
      )
    ).data
  },

  applyTasks: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/user-replacements/apply-tasks`,
        payload,
        getAxiosOptions(user),
      )
    ).data
  },
}
